// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 767) return "js/dashboard/767.js";
	if (chunkId === 130) return "js/dashboard/130.js";
	if (chunkId === 554) return "js/dashboard/554.js";
	if (chunkId === 590) return "js/dashboard/590.js";
	if (chunkId === 408) return "js/dashboard/408.js";
	if (chunkId === 123) return "js/dashboard/123.js";
	if (chunkId === 163) return "js/dashboard/163.js";
	if (chunkId === 892) return "js/dashboard/892.js";
	if (chunkId === 769) return "js/dashboard/769.js";
	if (chunkId === 760) return "js/dashboard/760.js";
	if (chunkId === 435) return "js/dashboard/435.js";
	if (chunkId === 856) return "js/dashboard/856.js";
	if (chunkId === 410) return "js/dashboard/410.js";
	// return url for filenames based on template
	return undefined;
};